/* 🤖 this file was generated by svg-to-ts */
export const matIconPinInvoke: {
  name: 'pin-invoke';
  data: string;
} = {
  name: 'pin-invoke',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 12v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10v2H4v12h16v-6h2zm0-5c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zM9.34 12h2.24l-2.95 2.95 1.41 1.41L13 13.42v2.24h2V10H9.34v2z"/></svg>`
};
